import {enableProdMode, importProvidersFrom} from '@angular/core';
import {environment} from './environments/environment';
import {AppComponent} from './app/app.component';
import {bootstrapApplication} from '@angular/platform-browser';
import {AuthModule, ExpiredAuthInterceptor, UrlInterceptor} from '@uofu-uss/ngx-auth';
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {
  provideRouter,
  withComponentInputBinding,
  withInMemoryScrolling
} from '@angular/router';
import {routes} from './app/app-routing.module';
import {credentials, softwareCatalogApisPath} from './app/auth-info';
import {CacheInterceptor} from '@uofu-uss-aux/software-catalog-ng-core';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent,
  {
    providers: [
      importProvidersFrom(
        AuthModule.forRoot({
          credentialsByApp: credentials,
          gatewayApiPaths: softwareCatalogApisPath,
        }),
      ),
      provideHttpClient(withInterceptorsFromDi()),
      provideRouter(routes,
        withInMemoryScrolling({
          anchorScrolling: 'enabled',
          scrollPositionRestoration: 'enabled',
        }),
        withComponentInputBinding()),
      {provide: HTTP_INTERCEPTORS, useClass: ExpiredAuthInterceptor, multi: true},
      {provide: HTTP_INTERCEPTORS, useClass: CacheInterceptor, multi: true},
      {provide: HTTP_INTERCEPTORS, useClass: UrlInterceptor, multi: true},
      {provide: Document, useValue: document},
      {provide: Window, useValue: window},
    ]
  });
